import React, { useState, useEffect, useMemo } from "react";
import { Formik, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Dropdown } from "react-bootstrap";
import axios from "axios";

import InputComponent from "../../../common/form/input";
import { API_CONFIG } from "../../../common/constant";

const SignupForm = (props) => {
  const [fullName, setFullName] = useState();
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [country, setCountry] = useState("");
  const [countryOptions, setCountryOptions] = useState([]);

  const getCountries = async () => {
    try {
      const response = await axios.get(API_CONFIG.countryList);

      const countries = response?.data?.countries || [];

      const formattedData = countries.map((country) => ({
        value: country.code,
        label: country.name,
        flag: country.fullFlagUrl,
      }));

      setCountryOptions(formattedData);
    } catch (error) {
      console.error("Error fetching countries:", error);
    }
  };

  const countryOptionsMap = useMemo(() => {
    return countryOptions.reduce((acc, option) => {
      acc[option.value] = option;
      return acc;
    }, {});
  }, [countryOptions]);

  useEffect(() => {
    getCountries();
  }, []);

  return (
    <Formik
      initialValues={{
        fullName: fullName,
        email,
        password,
        country,
      }}
      enableReinitialize
      onSubmit={props.signup}
      validationSchema={ValidationSchema}
    >
      {({ handleSubmit, values, setFieldValue }) => (
        <form
          onSubmit={handleSubmit}
          className="signup-form d-flex justify-content-between flex-column"
        >
          <div className="form-item">
            <Field name="fullName" type="text" value={values.fullName}>
              {(props) => (
                <InputComponent
                  {...props}
                  name="fullName"
                  type="text"
                  placeholder="Full Name"
                />
              )}
            </Field>
            <ErrorMessage component="span" className="error" name="fullName" />
          </div>
          <div className="form-item">
            <Field name="email" type="text" value={values.email}>
              {(props) => (
                <InputComponent
                  {...props}
                  name="email"
                  type="text"
                  placeholder="E-mail"
                />
              )}
            </Field>
            <ErrorMessage component="span" className="error" name="email" />
          </div>
          {/* <div className='form-item'>
                            <Field 
                                name='contactNumber'
                                type='text'
                                value={values.contactNumber}
                            >
                                {props => (<InputComponent 
                                        {...props}
                                        name='contactNumber'
                                        type='text'
                                        placeholder='Contact Number'
                                    />)}
                            </Field>
                            <ErrorMessage component='span' className='error' name='contactNumber' />
                        </div> */}
          <div className="form-item">
            <Dropdown
              onSelect={(eventKey) => setFieldValue("country", eventKey)}
            >
              <Dropdown.Toggle
                variant="light"
                id="dropdown-country"
                className="input-box d-flex align-items-center justify-content-between"
                style={{ backgroundColor: "#fff", height: "46px" }}
              >
                {values.country && countryOptionsMap[values.country] ? (
                  <div className="d-flex align-items-center">
                    <img
                      src={countryOptionsMap[values.country].flag}
                      alt=""
                      style={{ width: "24px", marginRight: "10px" }}
                    />
                    {countryOptionsMap[values.country].label}
                  </div>
                ) : (
                  <span style={{ color: "#777" }}>Select a country</span>
                )}
              </Dropdown.Toggle>

              <Dropdown.Menu
                style={{ width: "100%", maxHeight: "200px", overflowY: "auto" }}
              >
                {countryOptions.map((countryOpt) => (
                  <Dropdown.Item
                    eventKey={countryOpt.value}
                    key={countryOpt.value}
                    className="d-flex align-items-center"
                    style={{ padding: "8px 12px" }}
                  >
                    <img
                      src={countryOpt.flag}
                      alt={countryOpt.label}
                      style={{ width: "24px", marginRight: "10px" }}
                    />
                    {countryOpt.label}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
            <ErrorMessage component="span" className="error" name="country" />
          </div>
          <div className="form-item">
            <Field name="password" type="password" value={values.password}>
              {(props) => (
                <InputComponent
                  name="password"
                  {...props}
                  type="password"
                  placeholder="Password"
                />
              )}
            </Field>
            <ErrorMessage component="span" className="error" name="password" />
          </div>
          <button
            disabled={props.loading}
            type="submit"
            className="button button--primary button-full-width"
          >
            Sign up
          </button>
        </form>
      )}
    </Formik>
  );
};

const ValidationSchema = Yup.object({
  fullName: Yup.string().required("Please eneter full name"),
  email: Yup.string()
    .email("Please enter valid email id")
    .required("Please enter email"),
  password: Yup.string().required("Please enter password"),
  country: Yup.string().required("Please select a country"),
});

export default SignupForm;
